import React, { useState, useEffect } from "react";
import { FaWallet } from "react-icons/fa";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input'


export default function BillsPlanPopUp(props) {
    const [nome, setNome] = useState("");

    useEffect(() => {
        if (props.billsPlan && Object.keys(props.billsPlan).length > 0)
            setNome(props.billsPlan.nome);
    }, [props.billsPlan]);

    return (
        <Popup
            icon={<FaWallet />}
            tittle={props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <Input
                label="Nome*"
                placeholder="Digite o nome do plano de contas"
                id="new-cost-plan-popup-nome"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <button onClick={() => props.onClick({ nome })}>{props.buttonTittle}</button>
        </Popup>
    )
}